import api from '@/plugins/request/index';

// 公告消息列表
export const getNoticeMsgList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/notice/message`, params).then(res => res);
}
// 公告消息变为已读
export const updateNoticeRead = async (id, type = 'put') => {
  return api[type](`/gateway/v1/notice/message/${id}/read`).then(res => res);
}
// 小云消息详情
export const getXiaoyunDetail = async (params, type = 'get') => {
  return api[type](`/gateway/v1/message/xiaoyun/info`, params).then(res => res);
}
// 小云消息详情-400未接听选项
export const getXiaoyunImCallOpt = async (params, type = 'get') => {
  return api[type](`/gateway/v1/sale-helper/admin-call-options`, params).then(res => res);
}
// 小云消息-400未接听列表
export const getXiaoyunImList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/sale-helper/admin-call-list`, params).then(res => res);
}
// 小云消息-资料不完整用户列表
export const getXiaoyunImcompleteList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/sale-helper/admin-customer-info-list`, params).then(res => res);
}
// 小云消息-新客户汇总列表
export const getXiaoyunNewCustomeList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/sale-helper/new-customer`, params).then(res => res);
}
// 实时小云消息
export const getXiaoyunRealtimeMsg = async (type = 'get') => {
  return api[type](`/gateway/v1/message/xiaoyun/real-time/info`).then(res => res);
}
// 导出任务列表
export const importExportList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/quest/import-export`, params).then(res => res);
}
// 导出任务未完成数
export const importExportCount = async (type = 'get') => {
  return api[type](`/gateway/v1/quest/import-export/count`).then(res => res);
}

//新工作台
//工作台-数据简报-个人
export const getQuickDataByAdmin = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/board/admin`, params).then(res => res);
}
//工作台-数据简报-公司
export const getQuickDataByCompany = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/board/company`, params).then(res => res);
}
//工作台-数据简报-新客分析
export const getAnalysisByNew = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/board/new-customer`, params).then(res => res);
}
//工作台-数据简报-进线客户分析
export const getAnalysisByInline = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/board/thread-customer`, params).then(res => res);
}
//工作台-内容项模块-快捷操作
export const getQuickOperation = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/board/op`, params).then(res => res);
}
//工作台-内容项模块-云门店消息
export const getQuickShopMsg = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/board/shop-msg`, params).then(res => res);
}
//工作台-获取设置
export const getQuickSetting = async (params, type = 'get') => {
  return api[type](`/gateway/v1/report/board/setting`, params).then(res => res);
}
//工作台-提交设置
export const submitQuickSetting = async (params, type = 'post') => {
  return api[type](`/gateway/v1/report/board/setting`, params).then(res => res);
}
//工作台-内容项模块-待办任务
export const geTaskList = async (type = 'get') => {
  return api[type](`/gateway/v1/report/board/task`).then(res => res);
}